import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Measurement_Uncertainty_Report_Table from "./measurement_uncertainty_report_table/Measurement_Uncertainty_Report_Table";
import Measurement_Uncertainty_Report_Filter from "./measurement_uncertainty_report_filter/Measurement_Uncertainty_Report_Filter";
import { useDispatch, useSelector } from "react-redux";
import { GetMesurmentUncertinityReport } from "../../../../../features/admin/report_generator/Slice";
import { GetAll } from "../../../../../features/admin/quality_management/process_requirement/measurement_uncertainty/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";


const Measurement_Uncertainty_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const measurementdatadetails = useSelector(
    (state) => state.measurement_type_data,
  );
  const [searchParams, setSearchParams] = useState({
    parameter_id: "",
    end_date: "",
    start_date: "",
  });
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: measurementdatadetails.per_page,
        parameter_id: searchParams?.parameter_id?.value,
        end_date: searchParams.end_date,
        start_date: searchParams.start_date,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);

   const haveReportPermission = permissions?.includes(
      FixIDS.measurement_uncertainity_report.Report
    );

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetMesurmentUncertinityReport({
        page: 1,
        per_page: measurementdatadetails.per_page,
        parameter_id: searchParams?.parameter_id?.value,
        end_date: searchParams.end_date,
        start_date: searchParams.start_date,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Measurement Uncertainty Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Measurement_Uncertainty_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Measurement_Uncertainty_Report_Table
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          measurementdatadetails={measurementdatadetails}
        />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Measurement_Uncertainty_Report;
